import { getDomInteractive } from './performanceListener';

const onDomInteractive = response => {
  getDomInteractive().then(domInteractive => response(domInteractive));
};

export default onDomInteractive;
